import { Progress } from "@mantine/core";
import React        from "react";

import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const TaskProgress = ( { data } ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	const { description, subtext, targetValue, totalvalue } = data;
	const percentageValue                                   = ( 100 / targetValue ) * totalvalue;

	return (
		<div className = { classes.progressBarWrapper }>
			<Typography
				title     = { description }
			/>

			<Progress
				className = { classes.progressIndicator }
				radius    = "md"
				size      = "lg"
				value     = { percentageValue }
			/>

			<Typography
				className = { classes.progressInfo }
				title     = { `${ totalvalue }/${ targetValue } ${ subtext }` }
			/>
		</div>
	);
};

export default TaskProgress;